export const local_time = (start: string, end: string) => {
    if (!start || !end || start === "" || end === "") return { start: { date: "", time: "" }, end: { date: "", time: "" } };
    const converted_start = time_converter(start);
    const converted_end = time_converter(end);
    return { start: { date: converted_start[0] || "", time: converted_start[1]?.slice(0, 5) || "" }, end: { date: converted_end[0] || "", time: converted_end[1]?.slice(0, 5) || "" } };
};

const time_converter = (time: string): string[] => new Date(new Date(time).getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T");
